import {remCalc} from '_themeUtils'
import NewsletterModalStep1 from './partials/newsletter-step_1'
import NewsletterModalStep2 from './partials/newsletter-step_2'
import NewsletterModalStep3 from './partials/newsletter-step_3'

const NewsletterModal = {
    NewsletterModal: {
        baseStyle: () => ({
            wrapperNewsletter: {
                h: '100%',
            },
            sizes: {
                md: {
                    wrapper: {
                        w: {base: `calc( 100% - ${remCalc(30)})`},
                    },
                },
            },
        }),
    },
}

const newsletter = {
    ...NewsletterModal,
    ...NewsletterModalStep1,
    ...NewsletterModalStep2,
    ...NewsletterModalStep3,
}

export default newsletter
